import React, { FC } from 'react'
import { TextButton } from 'components/Button'

type Props = {
  calendarType: 'daily' | 'monthly'
  onClick: () => void
}

const ToggleCalendarButton: FC<Props> = React.memo((props) => {
  const { calendarType, onClick } = props

  return <TextButton label={`${calendarType === 'daily' ? '月' : '日'}表示に切り替え`} onClick={onClick} />
})

export default ToggleCalendarButton
